let traitsData = {

    // Holy shit moments
    'Risk Taker': {'holy_shit_moment_chance_multiplier': 2.4, 'gimmick_match_fatigue_multiplier': 1.4,
                   'category': 'Holy Shit Moments', 'conflicting_traits': ['Risk Averse'],
                   'description': 'This worker is eager to take risks in gimmick matches. They can create more amazing moments than others.',
                   'order': 1},
    'Risk Averse': {'holy_shit_moment_chance_multiplier': 0.2, 'gimmick_match_fatigue_multiplier': 0.6,
                    'category': 'Holy Shit Moments', 'conflicting_traits': ['Risk Taker', 'Gifted Acrobat'],
                    'description': 'This worker is a little afraid of risks. They aren\'t able to take full advantage of gimmick matches.',
                    'can_unlearn': true, 'staff_role_to_unlearn': 'trainer',
                    'order': 2},
    'Gifted Acrobat': {'holy_shit_moment_chance_multiplier': 1.6, 'overness_increase_multiplier': 1.25,
                       'category': 'Holy Shit Moments',
                       'conflicting_traits': ['Risk Averse'],
                       'description': 'This worker is a natural at performing stunning moves and unbelievable leaps that the fans love.',
                       'order': 3},
    'Stiff Worker': {'holy_shit_moment_pure_chance_multiplier': 1.8, 'category': 'Holy Shit Moments',
                     'conflicting_traits': [],
                     'description': 'This worker likes to work a strong style in matches. They are better suited towards \'pure\' style companies.',
                     'order': 4},

    // Injuries
    'Injury Prone': {'injury_chance_multiplier': 2.0, 'category': 'Injuries',
                     'conflicting_traits': ['Injury Resilient'],
                     'description': 'This worker has a history of injuries. A slight misstep could lead to many months of inactivity.',
                     'can_unlearn': true, 'staff_role_to_unlearn': 'doctor',
                     'acquirable': true, 'action_to_acquire': 'injuries', 'requirements_to_acquire': [],
                     'progress_per_action': 8, 'minimum_progress_to_acquire': 20, 'order': 1},
    'Injury Resilient': {'injury_chance_multiplier': 0.5, 'category': 'Injuries',
                         'conflicting_traits': ['Injury Prone'],
                         'description': 'This worker is tough, careful and lucky. Injuries seem to escape them.',
                         'order': 2},
    'Dangerous Worker': {'cause_injury_chance_multiplier': 3.0, 'add_blood_to_opponent_chance_boost': 8,
                         'category': 'Injuries', 'conflicting_traits': [],
                         'description': 'This worker is a danger to others in the ring. Opponents have a higher chance to get injured and bleed during matches with them.',
                         'can_unlearn': true, 'staff_role_to_unlearn': 'trainer',
                         'acquirable': true, 'action_to_acquire': 'injuries inflicted',
                         'requirements_to_acquire': ['2*_workrate_or_lower'],
                         'progress_per_action': 8, 'minimum_progress_to_acquire': 15, 'order': 3},

    // Matches
    'Ring General': {'positive_match_rating_boost_multiplier': 10, 'negative_match_rating_boost_multiplier': 0.5,
                     'category': 'Matches', 'conflicting_traits': ['Dull Worker'],
                     'description': 'This worker knows how to add good effects to their matches.',
                     'acquirable': true,
                     'action_to_acquire': '4.5* or higher one-on-one Matches with positive effects',
                     'requirements_to_acquire': ['3*_workrate'], 'progress_per_action': 1,
                     'minimum_progress_to_acquire': 10,
                     'order': 1},
    'Dull Worker': {'positive_match_rating_boost_multiplier': 0.5, 'negative_match_rating_boost_multiplier': 10,
                    'category': 'Matches', 'conflicting_traits': ['Ring General'],
                    'description': 'This worker seems to attract bad effects in their matches.',
                    'can_unlearn': true, 'staff_role_to_unlearn': 'trainer',
                    'acquirable': true, 'action_to_acquire': '2.5* or lower one-on-one Matches with negative effects',
                    'requirements_to_acquire': ['1*_workrate'],
                    'progress_per_action': 2, 'minimum_progress_to_acquire': 10, 'order': 2},
    'Workhorse': {'hot_match_chance_boost': 10, 'category': 'Matches', 'conflicting_traits': [],
                  'description': 'This worker goes the extra mile in matches, working harder than most others.',
                  'acquirable': true, 'action_to_acquire': 'hot Matches',
                  'requirements_to_acquire': ['3*_workrate'], 'progress_per_action': 1,
                  'minimum_progress_to_acquire': 15,
                  'order': 3},
    'Big Match Specialist': {'monthly_event_match_rating_boost': 0.4, 'monthly_event_match_fatigue_change': 4,
                             'category': 'Matches', 'conflicting_traits': ['Big Stage Wreck'],
                             'description': 'This worker goes into a higher gear on the big stage.',
                             'acquirable': true,
                             'action_to_acquire': '5* or higher one-on-one Matches on monthly events',
                             'requirements_to_acquire': ['2*_workrate_or_higher'],
                             'progress_per_action': 1, 'minimum_progress_to_acquire': 15, 'order': 4},
    'Big Stage Wreck': {'weekly_show_match_rating_boost': 0.2, 'monthly_event_match_rating_boost': -0.4,
                        'category': 'Matches', 'conflicting_traits': ['Big Match Specialist', 'Weekly Sloth'],
                        'description': 'This worker gets nervous on the big stage but performs better on weekly shows.',
                        'can_unlearn': true, 'staff_role_to_unlearn': 'talent_manager',
                        'order': 5},
    'Weekly Sloth': {'weekly_show_match_rating_boost': -0.4, 'monthly_event_match_rating_boost': 0.2,
                     'weekly_show_match_fatigue_change': -2,
                     'category': 'Matches', 'conflicting_traits': ['Big Stage Wreck'],
                     'description': 'This worker phones it in on weekly shows but performs better on monthly events.',
                     'can_unlearn': true, 'staff_role_to_unlearn': 'talent_manager',
                     'order': 6},

    // Gimmick match boost
    'Enjoys Gimmick Matches': {'gimmick_match_multiplier': 3, 'category': 'Matches',
                               'conflicting_traits': ['Hates Gimmick Matches'],
                               'description': 'This worker performs better in gimmick matches than others.',
                               'order': 7},
    'Hates Gimmick Matches': {'gimmick_match_multiplier': -3, 'category': 'Matches',
                              'conflicting_traits': ['Enjoys Gimmick Matches', 'Match Expert'],
                              'description': 'This worker finds it difficult to take advantage of gimmick matches.',
                              'can_unlearn': true, 'staff_role_to_unlearn': 'trainer',
                              'order': 8},
    'Match Expert': {'gimmick_match_multiplier': 4, 'gimmick_match_fatigue_multiplier': 0.6, 'category': 'Matches',
                     'conflicting_traits': ['Hates Gimmick Matches'],
                     'description': 'This worker has discovered a love for a particular kind of gimmick match and excels in it.',
                     'acquirable': true, 'action_to_acquire': '5* or higher one-on-one Gimmick Matches',
                     'requirements_to_acquire': ['2*_workrate_or_higher'],
                     'progress_per_action': 2, 'minimum_progress_to_acquire': 10, 'order': 9},

    // Morale
    'Easy To Please': {'loss_affects_morale_chance': 40,
                       'category': 'Morale',
                       'conflicting_traits': ['Hard To Please', 'Rebel', 'Loyal', 'Extreme Emotions'],
                       'description': 'This worker is not too concerned with losing. A few losses here and there won\'t affect their happiness.',
                       'order': 1},
    'Hard To Please': {'win_affects_morale_chance': 60,
                       'category': 'Morale',
                       'conflicting_traits': ['Easy To Please', 'Rebel', 'Loyal', 'Extreme Emotions'],
                       'description': 'This worker can be a bit difficult. Once unhappy, they might need more than a single win to win them over.',
                       'order': 2},
    'Loyal': {'loss_affects_morale_chance': 20, 'leaving_chance_multiplier': 0.25,
              'category': 'Morale',
              'conflicting_traits': ['Rebel', 'Easy To Please', 'Hard To Please', 'Extreme Emotions'],
              'description': 'This worker is devoted to the company and is more difficult to poach. It takes some doing to make them decide to leave.',
              'order': 3},
    'Rebel': {'win_affects_morale_chance': 30, 'leaving_chance_multiplier': 2.0,
              'category': 'Morale',
              'conflicting_traits': ['Loyal', 'Easy To Please', 'Hard To Please', 'Extreme Emotions'],
              'description': 'This worker is likely to leave at the slightest chance and is easier to poach.',
              'order': 4},
    'Extreme Emotions': {'win_affects_morale_chance': 30, 'loss_affects_morale_chance': 20,
                         'category': 'Morale',
                         'conflicting_traits': ['Easy To Please', 'Hard To Please', 'Rebel', 'Loyal'],
                         'description': 'This worker is easy to deal with when happy, but if you get on their bad side, it\'s tough to get them to stay.',
                         'order': 5},
    'Giving Veteran': {'no_morale_change_except_rank': 'Jabroni', 'category': 'Morale', 'conflicting_traits': [],
                       'description': 'This worker likes to give back to the business and is happy to put over most talent.',
                       'acquirable': true, 'action_to_acquire': 'turning part-timer',
                       'requirements_to_acquire': ['2*_workrate_or_higher', 'dedicated_wrestler_trait_present'],
                       'progress_per_action': 25, 'minimum_progress_to_acquire': 25, 'order': 6},
    'Star Maker': {'no_morale_change_rank': 'Upper Midcarder', 'category': 'Morale', 'conflicting_traits': [],
                   'description': 'This worker believes they can make stars out of rising talent and are willing to lose to them.',
                   'acquirable': true,
                   'action_to_acquire': 'losses in 4* or higher one-on-one Matches vs Upper Midcarders',
                   'requirements_to_acquire': [],
                   'progress_per_action': 2, 'minimum_progress_to_acquire': 15, 'order': 7},
    'Spotlight Lover': {'no_morale_change_rank': 'Main Eventer', 'category': 'Morale', 'conflicting_traits': [],
                        'description': 'This worker enjoys being in the spotlight, even if that means losing.',
                        'acquirable': true,
                        'action_to_acquire': 'losses in 4.5* or higher one-on-one Matches vs Main Eventers',
                        'requirements_to_acquire': [],
                        'progress_per_action': 1, 'minimum_progress_to_acquire': 15, 'order': 8},

    // Training
    'Quick Learner': {'skill_xp_multiplier': 1.15, 'training_xp_multiplier': 1.25,
                      'months_to_unlearn_traits_boost': 1,
                      'category': 'Progress',
                      'conflicting_traits': ['Slow Learner', 'Loves Training', 'Hates Training', 'Self Learner',
                                             'Lacks Self Learning'],
                      'description': 'This worker has a sharp mind and is quick to learn new things.',
                      'order': 1},
    'Slow Learner': {'skill_xp_multiplier': 0.8, 'training_xp_multiplier': 0.8,
                     'months_to_unlearn_traits_boost': -1,
                     'category': 'Progress',
                     'conflicting_traits': ['Quick Learner', 'Loves Training', 'Hates Training', 'Self Learner',
                                            'Lacks Self Learning'],
                     'description': 'This worker is slower at learning new things than others.',
                     'order': 2},
    'Loves Training': {'training_xp_multiplier': 1.5,
                       'category': 'Progress',
                       'conflicting_traits': ['Hates Training', 'Quick Learner', 'Slow Learner'],
                       'description': 'This worker puts in extra effort when training and learns faster from it.',
                       'order': 3},
    'Hates Training': {'training_xp_multiplier': 0.7, 'neglected_training_superstar_chance': 60,
                       'category': 'Progress',
                       'conflicting_traits': ['Loves Training', 'Quick Learner', 'Slow Learner'],
                       'description': 'This worker tends to slack off during training. This doesn\'t allow them to learn as much from training sessions.',
                       'can_unlearn': true, 'staff_role_to_unlearn': 'trainer',
                       'order': 4},
    'Self Learner': {'skill_xp_multiplier': 1.3,
                     'category': 'Progress',
                     'conflicting_traits': ['Lacks Self Learning', 'Quick Learner', 'Slow Learner'],
                     'description': 'This worker is good at developing their skills by being in matches and segments.',
                     'order': 5},
    'Lacks Self Learning': {'skill_xp_multiplier': 0.7,
                            'category': 'Progress',
                            'conflicting_traits': ['Self Learner', 'Quick Learner', 'Slow Learner'],
                            'description': 'This worker doesn\'t learn as much from being in matches and segments. Instead, they need good training.',
                            'order': 6},

    // Contract Status
    'Dedicated Wrestler': {'retirement_chance_multiplier': 0.5, 'retirement_age_change': 2,
                           'part_timer_chance_multiplier': 0.5, 'turn_part_timer_age_change': 2,
                           'category': 'Career', 'conflicting_traits': ['Lifelong Wrestler', 'Other Interests'],
                           'complimentary_traits': ['Leader', 'Ages Well', 'Injury Resilient'],
                           'description': 'This worker loves the business and wants to stay active longer than others.',
                           'disable_lose_with_age': true, 'order': 1},
    'Lifelong Wrestler': {'retirement_age_change': 10, 'retirement_chance_multiplier': 0.5,
                          'category': 'Career', 'conflicting_traits': ['Dedicated Wrestler', 'Other Interests'],
                          'description': 'This worker lives and breathes the business. They never want to retire.',
                          'disable_lose_with_age': true, 'order': 2},
    'Other Interests': {'part_timer_chance_multiplier': 1.5, 'turn_part_timer_age_change': -5,
                        'category': 'Career', 'conflicting_traits': ['Dedicated Wrestler', 'Lifelong Wrestler'],
                        'description': 'This worker has other interests in life. The time could come early when they decide to leave and pursue them.',
                        'order': 3},

    // Overness
    'Natural Charisma': {'overness_increase_multiplier': 1.5, 'overness_decrease_multiplier': 0.5,
                         'category': 'Overness/Alignment', 'conflicting_traits': ['Naturally Stale'],
                         'description': 'This worker oozes charisma. They have an easier road to getting over with the fans.',
                         'order': 1},
    'Naturally Stale': {'overness_increase_multiplier': 0.5, 'overness_decrease_multiplier': 1.5,
                        'category': 'Overness/Alignment', 'conflicting_traits': ['Natural Charisma'],
                        'description': 'This worker has a boring quality that makes them lean towards staleness in the eyes of the fans.',
                        'can_unlearn': true, 'staff_role_to_unlearn': 'producer',
                        'order': 2},

    // Alignment
    'Natural Babyface': {'face_alignment_hype_boost': 10, 'heel_alignment_penalty': -15,
                         'category': 'Overness/Alignment',
                         'conflicting_traits': ['Natural Heel'],
                         'description': 'This worker was born to play the good guy. They are more believable and work better when acting as a face.',
                         'order': 3},
    'Natural Heel': {'heel_alignment_hype_boost': 10, 'face_alignment_penalty': -15, 'category': 'Overness/Alignment',
                     'conflicting_traits': ['Natural Babyface'],
                     'description': 'This worker looks and acts like a bad guy. They work better when playing a heel.',
                     'order': 4},

    // Segments
    'Entertainer': {'hot_segment_chance_boost': 10, 'category': 'Segments', 'conflicting_traits': [],
                    'description': 'This worker is a natural at putting on entertaining segments.',
                    'acquirable': true, 'action_to_acquire': 'hot Segments',
                    'requirements_to_acquire': ['3*_charisma'], 'progress_per_action': 2,
                    'minimum_progress_to_acquire': 20,
                    'order': 1},
    'Comedy Chops': {'silly_segment_rating_boost': 0.1, 'category': 'Segments', 'conflicting_traits': ['Humorless'],
                     'description': 'This worker has a knack for comedy, making them excel at silly segments.',
                     'order': 2},
    'Humorless': {'silly_segment_rating_boost': -0.1, 'category': 'Segments', 'conflicting_traits': ['Comedy Chops'],
                  'description': 'This worker is a serious person who doesn\'t do well in silly segments.',
                  'can_unlearn': true, 'staff_role_to_unlearn': 'producer',
                  'order': 3},

    // Gimmicks
    'Character Worker': {'gimmick_boost': 15, 'gimmick_interview_superstar_chance': 60,
                         'category': 'Gimmicks', 'conflicting_traits': [],
                         'description': 'This worker gives special attention to their gimmick, committing themselves to the character.',
                         'order': 1},
    'Lore Master': {'fantasy_gimmick_character_boost': 20, 'non_fantasy_gimmick_character_boost': -40,
                    'category': 'Gimmicks', 'conflicting_traits': [],
                    'description': 'This worker shines when put in fantasy gimmicks. Monsters and Demons are their thing, Bodybuilders and Brutes, not so much.',
                    'order': 2},
    'Redeems Bad Gimmicks': {'bad_combination_gimmick_boost': 20, 'category': 'Gimmicks', 'conflicting_traits': [],
                             'description': 'This worker can turn awful gimmicks into something better.',
                             'order': 3},

    // Feuds
    'Storyteller': {'hot_feud_chance_boost': 10, 'feud_staleness_limit_boost': 1, 'feud_boosted_feud_chance': 75,
                    'category': 'Feuds', 'conflicting_traits': ['Neglects Story'],
                    'description': 'This worker engages in longer feuds and sticks to the story being told.',
                    'order': 1},
    'Neglects Story': {'hot_feud_chance_boost': -10, 'feud_staleness_limit_boost': -1, 'feud_ignored_feud_chance': 75,
                       'category': 'Feuds', 'conflicting_traits': ['Storyteller'],
                       'description': 'This worker works shorter feuds without focusing on the story too much.',
                       'can_unlearn': true, 'staff_role_to_unlearn': 'producer',
                       'order': 2},
    'Good Actor': {'feud_hype_change_boost': 3, 'gimmick_effectiveness_increase_multiplier': 1.5,
                   'gimmick_effectiveness_decrease_multiplier': 0.5, 'category': 'Feuds',
                   'conflicting_traits': ['Bad Actor'],
                   'description': 'This worker has good acting chops. They get the audience more invested in their feuds and character.',
                   'order': 3},
    'Bad Actor': {'feud_hype_change_boost': -3, 'gimmick_effectiveness_increase_multiplier': 0.5,
                  'gimmick_effectiveness_decrease_multiplier': 1.5, 'category': 'Feuds',
                  'conflicting_traits': ['Good Actor'],
                  'description': 'This worker can barely act. The audience is less invested in their feuds and character.',
                  'can_unlearn': true, 'staff_role_to_unlearn': 'producer',
                  'order': 4},

    // Backstage
    'Leader': {'morale_boost_helper_chance': 70, 'wrestler_court_judge_chance': 100, 'category': 'Backstage',
               'conflicting_traits': [],
               'description': 'This worker leads the locker room. They tend to help others and are the authority backstage.',
               'acquirable': true, 'action_to_acquire': 'helping with Morale Boost or being a judge in a Wrestlers Court', 'requirements_to_acquire': [],
               'progress_per_action': 8, 'minimum_progress_to_acquire': 20, 'order': 1},
    'Troublemaker': {'wrestler_court_defendant_chance': 50, 'backstage_fight_starter_chance': 50,
                     'category': 'Backstage', 'conflicting_traits': [],
                     'description': 'This worker has a tendency to get in trouble with others backstage. They can be difficult to manage.',
                     'can_unlearn': true, 'staff_role_to_unlearn': 'talent_manager',
                     'acquirable': true, 'action_to_acquire': 'starting a Backstage Fight', 'requirements_to_acquire': [],
                     'progress_per_action': 25, 'minimum_progress_to_acquire': 50, 'order': 2},
    'Drug Habit': {'drug_abuse_superstar_chance': 75, 'category': 'Backstage', 'conflicting_traits': [],
                   'description': 'This worker has a habit of recreational drug use that can interfere with their work.',
                   'can_unlearn': true, 'staff_role_to_unlearn': 'doctor',
                   'acquirable': true, 'action_to_acquire': 'being involved in Drug Abuse', 'requirements_to_acquire': [],
                   'progress_per_action': 25, 'minimum_progress_to_acquire': 50, 'order': 3},

    // Misc
    'Bleeder': {'add_blood_chance_boost': 20, 'category': 'Misc', 'conflicting_traits': [],
                'description': 'This worker loves to bleed. They are prone to using the razor on themselves in gimmick matches.',
                'acquirable': true, 'action_to_acquire': 'bleeding in Matches', 'requirements_to_acquire': [],
                'progress_per_action': 2, 'minimum_progress_to_acquire': 10, 'order': 1},
    'Tag Team Specialist': {'tag_match_workrate_boost': 0.5, 'category': 'Misc', 'conflicting_traits': [],
                            'description': 'This worker performs better in tag matches.',
                            'order': 2},
    'Ages Well': {'lose_trait_chance_multiplier': 0.25, 'remove_fatigue_age_penalty': true,
                  'category': 'Misc', 'conflicting_traits': [],
                  'description': 'This worker consistently practices their abilities and is less likely to lose them with age.',
                  'disable_lose_with_age': true, 'order': 3},

};

export {traitsData}